import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import DialButton from "../../../Buttons/DialButton/DialButton";
import EmailButton from "../../../Buttons/EmailButton/EmailButton";
import { formatPhoneNumber } from "../../../../utils/formatHelpers";

export default function ContactConnectCell(cell) {
  const [contactPhone, setContactPhone] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactMobilePhone, setContactMobilePhone] = useState("");
  const contact = cell?.row?.original;


  useEffect(() => {
    setContactPhone(formatPhoneNumber(contact?.phone));
    setContactEmail(contact?.email);
    setContactMobilePhone(formatPhoneNumber(contact?.mobile));
  }, [contact]);

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ marginRight: "4px" }}>
        <DialButton
          number={contactPhone}
          icon="phone"
          disabled={!contactPhone}
          color="blue"
        />
      </Box>
      <Box sx={{ marginRight: "4px" }}>
        <DialButton
          number={contactMobilePhone}
          icon="mobile"
          disabled={!contactMobilePhone}
          color="blue"
        />
      </Box>
      <EmailButton email={contactEmail} disabled={!contactEmail} color="blue" />
    </Box>
  );
}